<script>
import { mapActions } from "vuex";

export default {
  data() {
    return {
      showCookiesBanner: true,
      targetCookies: false,
      functionalCookies: false,
      operationalCookies: false,
    };
  },
  methods: {
    ...mapActions(["switchCookiesPopup"]),
    hideBanner() {
      this.showCookiesBanner = false;
      this.switchCookiesPopup(false);
      localStorage.setItem("cookies", this.showCookiesBanner);
    },
    // end banner nav
    setCookie(name, value, options = {}) {
      options = {
        path: "/",
        // при необходимости добавьте другие значения по умолчанию
        ...options,
      };

      if (options.expires instanceof Date) {
        options.expires = options.expires.toUTCString();
      }

      let updatedCookie =
        encodeURIComponent(name) + "=" + encodeURIComponent(value);

      for (let optionKey in options) {
        updatedCookie += "; " + optionKey;
        let optionValue = options[optionKey];
        if (optionValue !== true) {
          updatedCookie += "=" + optionValue;
        }
      }

      document.cookie = updatedCookie;
    },
    getCookie(name) {
      let matches = document.cookie.match(
        new RegExp(
          "(?:^|; )" +
            name.replace(/([\.$?*|{}\(\)\[\]\\\/\+^])/g, "\\$1") +
            "=([^;]*)"
        )
      );
      return matches ? decodeURIComponent(matches[1]) : undefined;
    },
    deleteCookie(name) {
      this.setCookie(name, "", {
        "max-age": -1,
      });
    },
    cookiesDelete() {
      var cookies = document.cookie.split(";");
      for (var i = 0; i < cookies.length; i++) {
        var cookie = cookies[i];
        var eqPos = cookie.indexOf("=");
        var name = eqPos > -1 ? cookie.substr(0, eqPos) : cookie;
        document.cookie = name + "=;expires=Thu, 01 Jan 1970 00:00:00 GMT;";
        document.cookie =
          name + "=; path=/; expires=Thu, 01 Jan 1970 00:00:01 GMT;";
      }
    },

    acceptAll() {
      this.targetCookies = true;
      this.functionalCookies = true;
      this.operationalCookies = true;

      this.hideBanner();
      this.acceptCookies();

      // setTimeout(() => {
      //   window.location.reload()
      // }, 1)
    },
    accept() {
      this.hideBanner();
      this.acceptCookies();

      // setTimeout(() => {
      //   window.location.reload()
      // }, 1)
    },
    acceptCookies() {
      this.cookiesDelete();
      let expires = new Date(new Date().valueOf() + 30000 * 60 * 60 * 24 * 15);
      document.cookie =
        "noofen-targetCookies=" +
        this.targetCookies +
        "; expires=" +
        expires;
      document.cookie =
        "noofen-functionalCookies=" +
        this.functionalCookies +
        "; expires=" +
        expires;
      document.cookie =
        "noofen-operationalCookies=" +
        this.operationalCookies +
        "; expires=" +
        expires;

      if (!this.showCookiesBanner) {
        let expires = new Date(
          new Date().valueOf() + 30000 * 60 * 60 * 24 * 15
        );
        document.cookie = "noofen-scb=false; expires=" + expires;
      }

      if (this.targetCookies) {
      }

      if (this.functionalCookies) {
        // -
        // console.log("functionalCookies");
      }

      if (this.operationalCookies) {
        // console.log("operationalCookies");
        // аналитике Гугла, Тег менеджера Гугла и Хотжар.

        (function (w, d, s, l, i) {
          w[l] = w[l] || [];
          w[l].push({
            "gtm.start": new Date().getTime(),
            event: "gtm.js",
          });
          var f = d.getElementsByTagName(s)[0],
            j = d.createElement(s),
            dl = l != "dataLayer" ? "&l=" + l : "";
          j.async = true;
          j.src = "https://www.googletagmanager.com/gtm.js?id=" + i + dl;
          f.parentNode.insertBefore(j, f);
        })(window, document, "script", "dataLayer", "GTM-WVCTX7JQ");
        // <!-- Global site tag (gtag.js) - Google Analytics -->
      } else {
        delete window.dataLayer;
        window.gtag = function(){
          // stub function
        }
        const cyrb53 = function (str, seed = 0) {
          let h1 = 0xdeadbeef ^ seed,
            h2 = 0x41c6ce57 ^ seed;
          for (let i = 0, ch; i < str.length; i++) {
            ch = str.charCodeAt(i);
            h1 = Math.imul(h1 ^ ch, 2654435761);
            h2 = Math.imul(h2 ^ ch, 1597334677);
          }
          h1 =
            Math.imul(h1 ^ (h1 >>> 16), 2246822507) ^
            Math.imul(h2 ^ (h2 >>> 13), 3266489909);
          h2 =
            Math.imul(h2 ^ (h2 >>> 16), 2246822507) ^
            Math.imul(h1 ^ (h1 >>> 13), 3266489909);
          return 4294967296 * (2097151 & h2) + (h1 >>> 0);
        };

        let clientIP = fetch("https://api.ipify.org?format=json")
          .then((x) => x.json())
          .then(({ ip }) => {
            return ip;
          });
        let validityInterval = Math.round(new Date() / 1000 / 3600 / 24 / 4);
        let clientIDSource =
          clientIP +
          ";" +
          window.location.host +
          ";" +
          navigator.userAgent +
          ";" +
          navigator.language +
          ";" +
          validityInterval;
        let clientIDHashed = cyrb53(clientIDSource).toString(16);

        window.dataLayer = window.dataLayer || [];

        gtag("js", new Date());
      }
    },
  },
  mounted() {
    if (localStorage.getItem("cookies") !== null) {
      this.showCookiesBanner = false;
    }
    if (!this.showCookiesBanner) {
      this.showCookiesBanner =
        this.getCookie("noofen-scb") !== "false" ? true : false;

      this.targetCookies =
        this.getCookie("noofen-targetCookies") === "true" ? true : false;
      this.functionalCookies =
        this.getCookie("noofen-functionalCookies") === "true"
          ? true
          : false;
      this.operationalCookies =
        this.getCookie("noofen-operationalCookies") === "true"
          ? true
          : false;

      this.acceptCookies();
    }
  },
};
</script>

<template>
  <div class="cookies" v-show="showCookiesBanner">
    <div class="content">
      <div class="cookies__icon">
        <img src="@/assets/icons/ui/dd_1.svg" />
      </div>

      <p class="cookies__title">Сайт использует куки</p>
      <p class="cookies__text">
        Наш сайт использует файлы куки (cookies), чтобы улучшить работу сайта,
        повысить его эффективность и удобство. Продолжая использовать сайт, Вы
        соглашаетесь на использование файлов куки.
        <a
          href="https://openolainfarm.uz/politika-ispolzovaniya-fajlov-kuki/"
          target="_blank"
          >Подробнее</a
        >
      </p>

      <div class="cookies__btns">
        <div
          class="cookies__btn cookies__btn--right"
          @click="
            acceptAll();
            $emit('closePopup');
          "
        >
          <p>Принять все</p>
        </div>

        <div
          class="cookies__btn cookies__btn-type2"
          @click="
            accept();
            $emit('closePopup');
          "
        >
          <p>Только необходимое</p>
        </div>
      </div>
    </div>
  </div>
</template>

<style scoped lang="scss">
.cookies {
  position: fixed;
  left: 0;
  top: 0;
  bottom: 0;
  right: 0;
  width: 100%;
  height: 100vh;

  z-index: 400;
  display: flex;
  justify-content: center;
  align-items: center;

  background: rgba(14, 45, 34, 0.9);
  backdrop-filter: blur(3px);

  padding: 20px;

  .content {
    position: relative;

    display: flex;
    flex-direction: column;

    max-width: 648px;
    width: 100%;
    padding: 40px;

    border-radius: 40px 90px 40px 40px;
    border: 1px solid rgba(255, 255, 255, 0.15);
    background: rgba(255, 255, 255, 0.1);
    backdrop-filter: blur(66.66667175292969px);

    @media screen and (max-width: 600px) {
      padding: 20px;
    }
  }

  &__title {
    color: var(--Text-White, #fff);
    font-size: 24px;
    font-weight: 700;
    line-height: 120%;

    margin-bottom: 10px;
  }

  &__text {
    color: var(--Text-White, #fff);
    font-size: 16px;
    line-height: 1.3;

    margin-bottom: 62px;

    @media screen and (max-width: 600px) {
      margin-bottom: 38px;
    }

    a {
      color: var(--9DFFDC, #9dffdc);

      @media screen and (min-width: 1024px) {
        &:hover {
          text-decoration-line: none;
        }
      }

      &:active {
        text-decoration-line: none;
      }
    }
  }

  &__icon {
    margin-bottom: 20px;
    width: 62px;
    height: 46px;

    &--icon2 {
      width: 46px;
      height: 46px;
    }
  }

  &__close {
    display: flex;
    justify-content: center;
    align-items: center;

    position: absolute;
    width: 48px;
    height: 48px;
    right: 0;
    top: 0;

    border: 1px solid rgba(255, 255, 255, 0.1);
    background: linear-gradient(
      180deg,
      rgba(255, 255, 255, 0.1) 0%,
      rgba(255, 255, 255, 0) 100%
    );
    box-shadow: 0px 0px 24px 0px rgba(228, 130, 255, 0.25) inset,
      0px 20.8px 16px 0px rgba(10, 5, 32, 0.17);
    backdrop-filter: blur(16px);

    @media screen and (min-width: 1024px) {
      &:hover {
        user-select: none;
        cursor: pointer;

        background: linear-gradient(
          180deg,
          rgba(255, 255, 255, 0.1) 0%,
          rgba(255, 255, 255, 0) 100%
        );
        border: 1.2px solid rgba(255, 255, 255, 0.3);
        box-shadow: inset 0px 0px 24px rgba(228, 130, 255, 0.25);
        filter: drop-shadow(0px 20.8px 16px rgba(10, 5, 32, 0.17));
        backdrop-filter: blur(16px);

        svg {
          path {
            stroke: var(--Accent-Purple, #e482ff);
          }
        }

        &:before {
          opacity: 1;
        }
      }
    }

    &:active {
      user-select: none;
      border: 1px solid rgba(255, 255, 255, 0.1);
      background: linear-gradient(
        180deg,
        rgba(255, 255, 255, 0.1) 0%,
        rgba(255, 255, 255, 0) 100%
      );
      filter: drop-shadow(0px 20.8px 16px rgba(10, 5, 32, 0.17));
      backdrop-filter: blur(16px);

      svg {
        path {
          stroke: var(--Accent-Purple, #e482ff);
        }
      }

      &:before {
        opacity: 0;
      }
    }

    &:before {
      content: "";

      opacity: 0;

      box-sizing: border-box;

      position: absolute;
      width: 100%;
      height: 2px;
      left: 0;
      right: 0;
      bottom: 0;

      background: linear-gradient(90deg, #d84cff 0%, #00cfff 100%);
      border-top: 0.45px solid rgba(255, 255, 255, 0.5);
    }

    svg {
      width: 17px;
      height: auto;
      display: block;
    }
  }

  &__btns {
    display: grid;
    justify-content: center;
    gap: 16px;

    margin-top: auto;
    width: 100%;

    @media screen and (min-width: 525px) {
      grid-template-columns: repeat(2, 1fr);
    }
  }

  &__btn {
    position: relative;
    overflow: hidden;

    display: flex;
    justify-content: center;
    align-items: center;

    padding: 8px 10px;

    max-width: 280px;
    width: 100%;
    height: 60px;

    border-radius: 60px;
    // box-shadow: 0px 7px 20.1px 0px rgba(156, 255, 172, 0.5);

    & > * {
      position: relative;
      z-index: 1;
    }

    &::before,
    &::after {
      content: "";
      position: absolute;
      border-radius: 60px;
    }

    &::before {
      top: 0;
      left: 0;
      width: 100%;
      height: 100%;

      background: radial-gradient(
        100% 100% at 50% 0%,
        rgba(255, 255, 255, 0.3) 0%,
        rgba(255, 255, 255, 0) 100%
      );
    }

    &::after {
      top: 2px;
      left: 2px;
      width: calc(100% - 4px);
      height: calc(100% - 4px);
    }

    &,
    &::after {
      background: radial-gradient(
          100% 100% at 50% 0%,
          rgba(255, 255, 255, 0.3) 0%,
          rgba(255, 255, 255, 0) 100%
        ),
        linear-gradient(0deg, #01cb93 0%, #60fe94 100%) #60fe94;
    }

    @media screen and (max-width: 600px) {
      max-width: 100%;
    }

    @media screen and (min-width: 1024px) {
      user-select: none;
      cursor: pointer;

      &:hover {
        &::before {
          background: radial-gradient(
            100% 100% at 50% 0%,
            rgba(255, 255, 255, 1) 0%,
            rgba(255, 255, 255, 0) 100%
          );
        }

        &,
        &::after {
          background: radial-gradient(
              100% 100% at 50% 0%,
              rgba(255, 255, 255, 0.3) 0%,
              rgba(255, 255, 255, 0) 100%
            ),
            linear-gradient(0deg, #00a175 0%, #60fe94 100%) #60fe94;
          // linear-gradient(0deg, #01cb93 0%, #60fe94 100%) #60fe94;
        }
      }

      &:active {
        

        &,
        &::after {
          background: radial-gradient(
              40% 40% at 50% 0%,
              rgba(255, 255, 255, 0.8) 0%,
              rgba(255, 255, 255, 0) 100%
            ),
            linear-gradient(0deg, #00a175 0%, #60fe94 100%) #60fe94;
        }
      }
    }

    p {
      color: var(--White, #fff);
      text-align: center;
      font-size: 18px;
      font-weight: 700;
      line-height: 1;
      letter-spacing: 0.36px;
      text-transform: uppercase;
    }

    &--right {
      // margin-right: 16px;
    }

    &--single {
      max-width: 280px;

      @media screen and (max-width: 600px) {
        max-width: 132px;
      }
    }

    // &:active {
    //   user-select: none;
    //   background: rgba(228, 130, 255, 0.1);
    //   cursor: pointer;
    //   p { color: #ffffff !important; }
    //   &:before { opacity: 0; }
    //   &:after { opacity: 0; }
    // }

    &-type2 {
      border-radius: 60px;
      // box-shadow: 0px 7px 20.1px 0px rgb(255, 221, 134, 0.5);

      &,
      &::after {
        background: radial-gradient(
            100% 100% at 50% 0%,
            rgba(255, 255, 255, 0.3) 0%,
            rgba(255, 255, 255, 0) 100%
          ),
          linear-gradient(0deg, #c97f57 0%, #ffb950 100%) #ffdd86;
      }

      @media screen and (min-width: 1024px) {
        &:hover,
        &:hover:after {
          background: radial-gradient(
              100% 100% at 50% 0%,
              rgba(255, 255, 255, 0.3) 0%,
              rgba(255, 255, 255, 0) 100%
            ),
            linear-gradient(0deg, #e97130 0%, #ffa825 100%) #ffa825;
        }

        &:active,
        &:active:after {
          background: radial-gradient(
              40% 40% at 50% 0%,
              rgba(255, 255, 255, 0.8) 0%,
              rgba(255, 255, 255, 0) 100%
            ),
            linear-gradient(0deg, #da753e 0%, #ffb341 100%) #ffb341;
        }
      }
    }
  }
}
</style>
